import { Field } from 'redux-form';
import * as React from 'react';

export class FormHelper {

  private static emptyComponent = () => null;

  /**
   * HACK: to remove reduxForm validations when another field with the same name is not showing,
   * but it leaves its validations active.
   * @param name
   */
  public static disabledValidationField(name: string) {
    return <Field name={name} component={this.emptyComponent} validate={[]}/>
  }

}
